import React from "react";
import {
  faCommentAlt,
  faFileInvoiceDollar,
  faFileLines,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
  GSButton,
  GSInfoCard,
  GSInfoGroup,
  defaultGapping,
  defaultPadding,
  golfstatusTypography,
} from "golfstatus_react_components";

import "./tournament-team-card.scss";
import { formatPhoneNumber } from "../../../helpers/Utilities";
import { displayPlayerHandicap } from "../../../helpers/Handicaps";

const iconButtonStyle = {
  width: golfstatusTypography.largeDisplayFont,
  height: golfstatusTypography.largeDisplayFont,
  ...defaultPadding.mediumPad.apply("vertical"),
  ...defaultPadding.mediumLargePad.apply("horizontal"),
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

const iconGlyphStyle = {
  fontSize: golfstatusTypography.mediumFont,
};

const TournamentTeamCard = (props) => {
  const {
    actionButtonClick,
    contactName,
    email,
    flag,
    header,
    messageClicked,
    onViewOrder,
    onViewResponses,
    phone,
    player,
    signupMessage,
    tournament,
    waitlistType,
  } = props;

  //const defaultAvatar = "https://api.golfstatus.dev/images/user_round.png";


  const contactInfo = {
    sectionItems: [
      {
        type: "primary no-wrap full-width capitalize",
        value: `${contactName} ${displayPlayerHandicap(player, tournament)}`,
      },
      {
        type: "secondary nowrap",
        value: email,
      },
      {
        type: "secondary nowrap",
        value: formatPhoneNumber(phone),
      },
    ],
  };

  const waitListTypeSection = {
    sectionItems: [
      {
        type: "secondary nowrap capitalize",
        value: waitlistType
      },
    ],
  };

  const actionButtons = (
    <div style={{ display: "inline-flex", ...defaultGapping.mediumGap }}>
      <GSButton
        type={`status secondary light-grey`}
        buttonIcon={faPlus}
        style={iconButtonStyle}
        iconStyle={iconGlyphStyle}
        onClick={(e) => {
          e?.stopPropagation?.();
          actionButtonClick(props?.isWaitList ? props?.member : props?.player);
        }}
      />
      {player?.registrationOrderKey && onViewOrder && (
        <GSButton
          type={`status secondary light-grey`}
          buttonIcon={faFileInvoiceDollar}
          style={iconButtonStyle}
          iconStyle={iconGlyphStyle}
          onClick={(e) => {
            e?.stopPropagation?.();
            onViewOrder?.(player);
          }}
        />
      )}
      {player && onViewResponses && (
        <GSButton
          type={`status secondary light-grey`}
          buttonIcon={faFileLines}
          style={iconButtonStyle}
          iconStyle={iconGlyphStyle}
          onClick={(e) => {
            e?.stopPropagation?.();
            onViewResponses?.(player);
          }}
        />
      )}
    </div>
  );

  const playerInfo = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: actionButtons,
      },
    ],
  };

  const pro = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: <GSButton type="secondary pill green" title="Pro" />,
      }
    ]
  };

  const message = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: <GSButton type="secondary" buttonIcon={faCommentAlt} onClick={(e) => {messageClicked?.({...props}); e?.stopPropagation?.()}} />,
      },
    ],
  };

  const teamInfo = {
    fit: "stretch",
    sections: [
      {...contactInfo},  
    ],
  };

  const additionalInfo = () => {
    let sections = [];
    if (flag === "pro") {
      sections.push({...pro});
    }
    if (signupMessage) {
      sections.push({...message});
    }

    return sections;
  };

  const getGroup = () => {
    if (waitlistType) {
      teamInfo.sections.push(waitListTypeSection);
    }
    teamInfo.sections.push(playerInfo);
    let group = [{ ...teamInfo }];

    if (additionalInfo().length > 0) {
      group.push({
        fit: "additional-info",
        sections: additionalInfo()
      });
    }
    
    return group;
  };
  
  return (
    <tournament-team-card class={header ? "header" : ""}>
      <GSInfoCard size="large" layout={ <GSInfoGroup dataGroups={getGroup()}></GSInfoGroup>}></GSInfoCard>
    </tournament-team-card>
  );
};

export default TournamentTeamCard;
